(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/utils/subscription-from-wager.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/utils/subscription-from-wager.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function subscriptionFromWager(wager) {
  const productIds = wager.selectedDays.length ? wager.selectedDays : [svs.numbergames.productMapping.getProductItsId(wager.productId)];

  const gameDays = productIds.map(itsProductId => svs.numbergames.productMapping.getDay(itsProductId)).join(' & ');
  let packageIdWager0;
  let packageIdWager1;
  if (wager.selectedPackage) {
    var _svs$numbergames$pay_;
    const bagTypes = (_svs$numbergames$pay_ = svs.numbergames.pay_numbergames) === null || _svs$numbergames$pay_ === void 0 || (_svs$numbergames$pay_ = _svs$numbergames$pay_.data) === null || _svs$numbergames$pay_ === void 0 ? void 0 : _svs$numbergames$pay_.bagTypes;
    [packageIdWager0, packageIdWager1] = productIds.map(productItsId => {
      var _bagTypes$find;
      return (_bagTypes$find = bagTypes.find(bag => bag.productItsId === productItsId && bag.size === wager.selectedPackage)) === null || _bagTypes$find === void 0 ? void 0 : _bagTypes$find.bagType;
    });
  }
  const baseJokerPrice = svs.numbergames.rules.joker.getRowPrice();
  const entry = {
    wagers: createWagers({
      productIds,
      wager
    }),
    packageIdWager0: packageIdWager0 || 0,
    packageIdWager1: packageIdWager1 || 0,
    rowpriceMain: svs.utils.format.CurrencyAsJupiterString(wager.rowPrice),
    rowpriceAddon: svs.utils.format.CurrencyAsJupiterString(baseJokerPrice)
  };
  if (wager.subscriptionId) {
    entry.subscriptionIdRef = wager.subscriptionId;
  }
  const options = {
    weeklyCost: wager.price,
    numberOfBoards: wager.numberOfValidBoards,
    jokerPrice: wager.jokerPrice,
    product: svs.numbergames.productMapping.getProductName(wager.productId),
    gameDays
  };
  return {
    entry,
    options
  };
}
function createWagers(_ref) {
  let {
    productIds,
    wager
  } = _ref;
  const {
    wagerAmount,
    prices,
    jokerPrices
  } = calculateWagerPrices({
    productIds,
    wager
  });
  return productIds.map(itsProductId => ({
    wagerAmount,
    bets: createBetList({
      itsProductId,
      wager,
      prices,
      jokerPrices
    })
  }));
}
function createBetList(_ref2) {
  let {
    itsProductId,
    wager,
    prices,
    jokerPrices
  } = _ref2;
  const betListItem = {
    numDraws: 1,
    betProperties: ['SUBSCRIPTION']
  };
  const betBoardType = getBetBoardType(itsProductId);
  const betList = [_objectSpread(_objectSpread(_objectSpread({}, betListItem), prices), {}, {
    [betBoardType]: createBetBoards(wager),
    productId: itsProductId
  })];
  if (wager.hasJoker) {
    betList.push(_objectSpread(_objectSpread(_objectSpread({}, betListItem), jokerPrices), {}, {
      productId: svs.numbergames.productMapping.getJokerProductId(itsProductId),
      jokerBoards: [{
        boardData: wager.jokerRow.map(_ref3 => {
          let {
            number
          } = _ref3;
          return parseInt(number, 10);
        }),
        boardProps: getBoardProps(wager.jokerRow)
      }]
    }));
  }
  return betList;
}
function createBetBoards(wager) {
  return wager.boards.map(board => {
    const betBoard = {
      boardProps: getBoardProps(board.numbers, board.numbersExtra),
      systemType: wager.isSystem ? ['MSYS'] : ['SROW'],
      systemNum: 0,
      participation: 0,
      rowPriceMulti: 1
    };
    if (board.numbersExtra) {
      betBoard.boardData1 = board.numbers.toArray();
      betBoard.boardData2 = board.numbersExtra.toArray();
    } else {
      betBoard.boardData = board.numbers.toArray();
    }
    if (svs.numbergames.productMapping.isLotto(wager.productId)) {
      betBoard.numSelections = board.numbers.length;
      betBoard.participation = wager.rowPriceMulti === 2 ? 'L1L2' : 'L1';
    }
    return betBoard;
  });
}
function calculateWagerPrices(_ref4) {
  let {
    productIds,
    wager
  } = _ref4;
  let betAmountSalesGroup2 = 0;
  let rowPriceMulti = wager.rowPriceMulti;
  let joker;
  const betAmountSalesGroup1 = (wager.price / productIds.length - wager.jokerPrice) / rowPriceMulti;

  if (rowPriceMulti === 2 && svs.numbergames.productMapping.isLotto(wager.productId)) {
    betAmountSalesGroup2 = betAmountSalesGroup1;
    rowPriceMulti = 1;
  }
  if (wager.hasJoker) {
    joker = {
      betAmountSalesGroup1: svs.utils.format.CurrencyAsJupiterString(wager.jokerPrice),
      betAmountSalesGroup2: svs.utils.format.CurrencyAsJupiterString(0),
      rowPriceMulti: wager.jokerPrice / 10
    };
  }
  return {
    wagerAmount: svs.utils.format.CurrencyAsJupiterString(wager.price / productIds.length),
    prices: {
      betAmountSalesGroup1: svs.utils.format.CurrencyAsJupiterString(betAmountSalesGroup1),
      betAmountSalesGroup2: svs.utils.format.CurrencyAsJupiterString(betAmountSalesGroup2),
      rowPriceMulti
    },
    jokerPrices: joker
  };
}
function getBetBoardType(product) {
  const boardTypes = {
    LOTTO: 'lottoBoards',
    JOKER: 'jokerBoards',
    EUROJACKPOT: 'extNumberBoards',
    VIKINGLOTTO: 'extNumberBoards',
    KENO: 'kenoBoards'
  };
  product = svs.numbergames.productMapping.getProductId(product);
  return boardTypes[product];
}
function getBoardProps(numbers) {
  let numbersExtra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  numbers = [...numbers, ...numbersExtra];
  const manualLength = numbers.filter(_ref5 => {
    let {
      manual
    } = _ref5;
    return manual;
  }).length;
  if (manualLength === 0) {
    return ['QUICKPICK'];
  }
  if (numbers.length > manualLength) {
    return ['PARTIALQP'];
  }
  return [];
}
svs.numbergames.game_model.utils.subscriptionFromWager = subscriptionFromWager;

 })(window);